import React, { useMemo, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

import ControldocDataTable from '../../controldoc/datatable';

import { laboralHiringColumns, laboralEmployeeColumns, abstractEntityColumns } from './columns_data';

const getTableColumns = (resourceModuleName) => {
  if(resourceModuleName === 'laboral_hiring'){
    return laboralHiringColumns();
  }

  if(resourceModuleName === 'laboral_employee'){
    return laboralEmployeeColumns();
  }

  return abstractEntityColumns();
};

const getHeadersByFilterKey = (tableColumns) => {
  const filterKeyHeaders = {};
  _.each(tableColumns, (col) => {
    const filterKey = _.get(col, 'filter.filterrific.search');
    if (filterKey) filterKeyHeaders[filterKey] = col?.header;
  });

  return filterKeyHeaders;
};

const renderColumnFilterOverlayStyle = () => {
  return <style>{'.p-column-filter-overlay { z-index: 200000 !important; }'}</style>;
};

const ComplianceActivityResourceModal = (props) => {
  const {
    activity,
    resourceLabel,
    filterrific,
    configuration: {
      indexEntitiesPath,
      entityKeyName,
      defaultRequestParams,
    },
    callbacks: {
      onChangeActivity: callbackOnChangeActivity,
      onSetFilterrific: callbackOnSetFilterrific,
    },
  } = props;

  const tableColumns = useMemo(() => {
    return getTableColumns(activity?.resource_module_name);
  }, [activity?.resource_module_name]);

  const headersByFilterKey = useMemo(() => {
    return getHeadersByFilterKey(tableColumns);
  }, [tableColumns]);

  const activeFilterKeys = useMemo(() => {
    return _.filter(_.keys(filterrific || {}), (key) => {
      if (key === 'show_all') return false;
      const value = filterrific[key];

      return value != null && String(value).trim() !== '';
    });
  }, [filterrific]);

  const activeFilters = useMemo(() => {
    let activeFilters = {}

    _.each(activeFilterKeys, (filterKey) => {
      activeFilters[filterKey] = filterrific[filterKey];
    });

    return activeFilters;
  }, [filterrific, activeFilterKeys]);

  useEffect(() => {
    if(activeFilterKeys?.length > 0){
      callbackOnChangeActivity({ target: { value: activeFilters }}, 'active_filters' );
    }
  }, [activeFilters]);

  const renderModal = () => {
    if(activity?.resource_module_name){
      return (
        <Col md="12">
          <div
            className="modal fade"
            id="moduleFilterModal"
            tabIndex="-1"
            aria-labelledby="moduleFilterModalLabel"
            aria-hidden="true"
            data-bs-focus="false"
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <div>
                    <h1 className="modal-title fs-5 fw-bold" id="moduleFilterModalLabel">
                      {_.capitalize(resourceLabel)}
                    </h1>
                    <p className="small mb-1">
                      Afina aún más tu selección dentro del módulo{" "}
                      <strong>{_.capitalize(resourceLabel)}</strong>{" "}
                      eligiendo recursos específicos.
                      Haz clic en el ícono de filtro (
                      <i className="fas fa-filter"></i>
                      ) para buscar y seleccionar.
                    </p>
                  </div>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  { renderSummary() }
                  {renderColumnFilterOverlayStyle()}
                  <ControldocDataTable
                    columns={tableColumns}
                    configuration={{
                      showDistributionListFilter: false,
                      showGridlines: true,
                      context: 'compliance',
                      onFilterrificChange: (f) => callbackOnSetFilterrific(f),
                      setTotalRecords: (total) => callbackOnChangeActivity({ target: { value: total }}, 'total_entity_records' ),
                      fetchRecords: {
                        endpoint: indexEntitiesPath,
                        keyName: entityKeyName,
                        defaultRequestParams: defaultRequestParams,
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      )
    }
  };

  const renderSummary = () => {
    return (
      <div className='card card-outline card-primary mt-3 alert-info'>
        <div className="card-body">
          <div className="mb-2 mb-md-0">
            <p className="mb-0 small">
              <i className="fas fa-database mr-2"></i>
              Total de registros seleccionados: <strong>{activity?.total_entity_records}</strong>
            </p>
          </div>

          <div className="mt-2">
            <p className="mb-0 small d-inline">
              <i className="fas fa-filter mr-2"></i>
              Filtros aplicados:
            </p>
            {
              activeFilterKeys?.length > 0 && (
                _.map(activeFilters, (value, key) => {
                  let header = headersByFilterKey[key];

                  return (
                    <span key={key} className="badge badge-info mr-1 mb-1">
                      {header}: <strong>{value}</strong>
                    </span>
                  )
                })
              )
            }
          </div>
        </div>
      </div>
    );
  };

  return (
    <Row>
      <Col md="12">
        { renderModal() }

        <div className="mt-3">
          { activity?.resource_module_name && activeFilterKeys ? renderSummary() : "" }
          {activity?.resource_module_name &&
            <div className="card bg-real-light">
              <div className="card-body d-flex gap-2 align-items-start">
                <i className="fas fa-filter fa-2x"></i>
                <div>
                  <h2 className="fs-6 fw-bold mb-0">
                    Selección Avanzada
                  </h2>
                  <p className="small mb-0">
                    Afina aún más tu selección dentro del módulo{" "}
                    <strong>{_.capitalize(resourceLabel)}</strong>{" "}
                    eligiendo recursos específicos.
                  </p>
                </div>
                <button
                  type="button"
                  className="btn btn-primary ml-auto"
                  data-bs-toggle="modal"
                  data-bs-target="#moduleFilterModal"
                  disabled={!activity?.resource_module_name}
                >
                  Filtros Avanzados
                </button>
              </div>
            </div>
          }
        </div>
      </Col>
    </Row>
  );
};

export default ComplianceActivityResourceModal;